var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHerring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA7;}\n\t.st1{fill:#B4B4B4;}\n\t.st2{fill:#E7E6E6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.86,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.57,149.93,61.17,184.22,103.86,184.22"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.18,111.44c-2.42,0.56-4.99,1.2-6.75,3.12c-0.66,0.72-1.17,1.6-1.68,2.46c-1.24,2.12-2.49,4.25-3.73,6.37 c4.22,1.87,9.02,0.04,13.02-2.37c3.99-2.4,7.86-5.44,12.37-6.13c1-0.15,3.05-0.56,2.59-2.23c-0.28-1.01-2.28-1.6-3.06-2.02 L58.18,111.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.18,111.45c-2.42-0.56-4.99-1.2-6.75-3.12c-0.66-0.72-1.17-1.6-1.68-2.46c-1.24-2.12-2.49-4.25-3.73-6.37 c4.22-1.87,9.02-0.04,13.02,2.37c3.99,2.4,7.86,5.44,12.37,6.13c1,0.15,3.05,0.56,2.59,2.23c-0.28,1.01-2.28,1.6-3.06,2.02 L58.18,111.45z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.01,104.1c-1.5-4.13-3.13-8.2-4.9-12.22c-0.88-2-1.84-4.05-3.5-5.48c-1.03,2.78-2.09,5.61-3.84,8.01 s-4.33,4.36-7.28,4.69c-0.56,0.06-1.22,0.13-1.49,0.62c-0.14,0.26-0.12,0.57-0.09,0.87c0.09,0.78,0.26,1.56,0.51,2.31 c0.12,0.35,0.27,0.71,0.57,0.92c0.27,0.18,0.61,0.2,0.94,0.22c6.34,0.33,12.67,0.64,19.01,0.92c-0.16-1.16-0.44-2.3-0.81-3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.79,125.88c0.79,0.66,1.66,1.36,2.69,1.44c0.74,0.06,1.5-0.21,2.23-0.07c0.49,0.09,0.93,0.37,1.24,0.76 c0.19,0.25,0.34,0.55,0.61,0.71c0.42,0.25,0.96,0.06,1.39-0.17c2.47-1.34,4.01-3.88,5.37-6.34c0.29-0.52,0.58-1.13,0.4-1.7 c-0.13-0.41-0.49-0.7-0.87-0.9c-1.63-0.85-6.33-1.48-7.87-0.38c-0.89,0.64-1.42,1.81-2.27,2.53c-1.35,1.14-3.09,1.73-4.54,2.68 C99.65,124.97,100.23,125.41,100.79,125.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.92,111.49c0.77-2.82,0.7-2.79-7.09-6.01c-8.23-3.4-39.29-6.17-51-3.24c-11.48,2.87-25.64,4.34-25.64,4.34 s-5.7,0.52-6.67,0.42c-0.97-0.1-3.92,3.27-2.77,5.3c1.15,2.03,4.35,3.41,9.32,3.27s14.84,4.95,21.32,6.47 c6.48,1.53,20.2,5.53,32.79,3.61c12.59-1.92,31.95-9.37,32.48-12.06C162.18,110.91,158.92,111.49,158.92,111.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.38,105.7c-10.41,1.14-16.65-0.66-38.99,0.28c-22.57,0.91-29.08,0.49-47.18,3.02 c0.75-1.17,1.78-2.08,2.3-2.01c0.97,0.1,6.68-0.42,6.68-0.42s14.14-1.46,25.62-4.35c11.71-2.92,42.78-0.16,51.01,3.24 C152.02,105.54,152.22,105.64,152.38,105.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerring);
export default __webpack_public_path__ + "static/media/Herring.ccc5c1c1330f1eba219015020405c1bc.svg";
export { ForwardRef as ReactComponent };